export class DadSearchCriteria {
  companyOrBillingAccount: string;
  status = [];
  exchanges = [];

  constructor(userChoicesActiveFilters) {
    this.companyOrBillingAccount = userChoicesActiveFilters.companyOrBillingAccount;
    this.status = userChoicesActiveFilters.status;
    this.exchanges = userChoicesActiveFilters.exchanges;
  }
}
